import type { FlattenedVariantOptions } from './types'
import type { QuickAddFormProps } from '../types'
import { flattenSelectedOptions } from './flattenSelectedOptions'

export const flattenVariantOptions: (
  variants: QuickAddFormProps['variants'],
) => FlattenedVariantOptions[] = (variants: QuickAddFormProps['variants']) =>
  variants.map((variant) => ({
    ...variant,
    options: flattenSelectedOptions(variant.selectedOptions),
  }))
